import React, { useState, useEffect } from 'react';
import { connect } from "trim-redux";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../../config/design/styles';
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import AddressHolder from "../../../../components/address/map/AddressHolder";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {calculateShopRadius} from "../../../../../config/values";

const ShopAddress = (props) => {
    const { classes } = props;
    const navigation = useNavigate();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    let { id } = useParams();
    if(!id && !props.create){
        if(!!props.user.shop){
            id = props.user.shop.id;
        }else{
            navigation('/')
        }
    }

    const [loading, setLoading] = useState(true);
    const [shopData, setShopData] = useState(null);
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/shops/get/${id}`,config)
            .then(response => {
                setShopData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        loadData();
    }, []);

    const handleAddressDone = () => {
        enqueueSnackbar(t('detailsSet'), { variant: 'success' });
    }

    if (loading) {
        return <AppCardLoaderFields />;
    }
    return (
        <Grid container spacing={2} justify="center" alignItems="center">
            <Grid item size={{xs:12}}>
                <AddressHolder
                    vendor
                    shop_id={id}
                    handleAddressDone={() => handleAddressDone()}
                    radius={calculateShopRadius(shopData)}
                />
            </Grid>
        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(ShopAddress));
